class SchedulesApiClient {
  constructor(client) {
    this.client = client
  }

  update(professional_id, data) {
    return this.client.put(`admin/v1/professionals/${professional_id}/schedules`, data)
  }
}

export default SchedulesApiClient
